import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AppGuard } from '@guards/app.guard'
import { OrganizationGuard } from '@guards/organization.guard'

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'login',
    redirectTo: 'auth',
  },
  {
    path: 'sso',
    loadComponent: () =>
      import('@pages/auth/auth-sso/auth-sso-modal.modal').then((m) => m.AuthSSOModal),
  },
  {
    path: 'lost',
    loadComponent: () => import('@pages/lost/lost.page').then((m) => m.LostPage),
  },
  {
    path: ':organizationId',
    canActivate: [OrganizationGuard],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('@pages/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'login',
        redirectTo: 'auth',
      },
      {
        path: '',
        loadChildren: () => import('@pages/pages.module').then((m) => m.PagesModule),
        canActivate: [AppGuard],
      },
      {
        path: 'custom',
        loadChildren: () =>
          import('./pages/modules/custom/custom.module').then((m) => m.CustomModule),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboards',
    pathMatch: 'full',
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
